import React, { ReactElement } from 'react';

import { CircleGhost } from '@/assets/icons/CircleGhost';
import { GhostIcon } from '@/assets/icons/GhostIcon';
import ArrowDown from '@/assets/icons/arrowDown';
import ArrowUp from '@/assets/icons/arrowUp';
import { CircleRescue } from '@/assets/icons/circle-rescue';
import { CircleRevive } from '@/assets/icons/circle-revive';
import { CircleSubtract } from '@/assets/icons/circle-subtract';
import { CircleTie } from '@/assets/icons/circle-tie';
import { CorrectThickIcon } from '@/assets/icons/correctThickIcon';
import { IncorrectIcon } from '@/assets/icons/incorrectIcon';
import { LossIcon } from '@/assets/icons/loss';
import { RescuedIcon } from '@/assets/icons/rescue-icon';
import { RevivedIcon } from '@/assets/icons/revive-icon';
import { TieIcon } from '@/assets/icons/tie-icon';
import { VoidIcon } from '@/assets/icons/voidIcon';
import WonIcon from '@/assets/icons/won';
import { ds } from '@/components/lib/design.system';
import { PickStatus } from '@/utils/pick-status';

/**
 * Every icon a pick status can wear, per surface. The two surfaces share almost no
 * artwork, so they stay separate maps — but they live together, so adding a status
 * is one file to open. `null` means the surface draws something else entirely.
 */
type PickStatusIcons = Record<PickStatus, ReactElement | null>;

/** The 24px slot on the right of a pick row in the entry details card. */
export const pickStatusIconMap: PickStatusIcons = {
    [PickStatus.UPCOMING]: null,
    [PickStatus.IN_PROGRESS_MORE]: null,
    [PickStatus.IN_PROGRESS_LESS]: null,
    [PickStatus.CORRECT]: <WonIcon color={ds.colorValue.icon.primary} testID={'won-icon'} />,
    [PickStatus.INCORRECT]: <LossIcon testID={'loss-icon'} />,
    [PickStatus.VOID]: <CircleSubtract testID={'standard-void-icon'} />,
    [PickStatus.REVIVED]: <CircleRevive testID={'revived-icon'} />,
    [PickStatus.RESCUED]: <CircleRescue color={ds.colorValue.icon.primary} testID={'rescued-icon'} />,
    [PickStatus.GHOSTED]: <CircleGhost testID={'ghosted-icon'} />,
    [PickStatus.TIE]: <CircleTie testID={'tie-icon'} />,
};

/** The 16px badge peeking below the player avatar. */
export const pickStatusBadgeMap: PickStatusIcons = {
    [PickStatus.UPCOMING]: null,
    [PickStatus.IN_PROGRESS_MORE]: <ArrowUp />,
    [PickStatus.IN_PROGRESS_LESS]: <ArrowDown />,
    [PickStatus.CORRECT]: <CorrectThickIcon />,
    [PickStatus.INCORRECT]: <IncorrectIcon />,
    [PickStatus.VOID]: <VoidIcon />,
    [PickStatus.REVIVED]: <RevivedIcon width={12} height={12} />,
    [PickStatus.RESCUED]: <RescuedIcon width={12} />,
    [PickStatus.GHOSTED]: <GhostIcon width={12} />,
    [PickStatus.TIE]: <TieIcon />,
};
